var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChargeSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 154,
    viewBox: "0 0 154 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 77C0 119.526 34.4741 154 77 154C119.526 154 154 119.526 154 77C154 34.4741 119.526 0 77 0C34.4741 0 0 34.4741 0 77Z",
    fill: "url(#paint0_linear_5073_30898)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.2135 116.658L35.3875 106.656C32.8858 106.154 31.265 103.719 31.767 101.217L37.6775 71.7743C38.1796 69.273 40.6147 67.6514 43.1164 68.1538L92.942 78.1561C95.4437 78.6581 97.0649 81.0933 96.5625 83.595L90.652 113.037C90.15 115.539 87.7152 117.16 85.2135 116.658Z",
    fill: "#0B2B46"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.773 101.546H45.2477C42.0583 101.546 39.4727 98.9599 39.4727 95.7705V58.233C39.4727 55.0437 42.0583 52.458 45.2477 52.458H108.773C111.962 52.458 114.548 55.0437 114.548 58.233V95.7705C114.548 98.9599 111.962 101.546 108.773 101.546Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.773 101.546H45.2477C42.0583 101.546 39.4727 98.9599 39.4727 95.7705V58.233C39.4727 55.0437 42.0583 52.458 45.2477 52.458H108.773C111.962 52.458 114.548 55.0437 114.548 58.233V95.7705C114.548 98.9599 111.962 101.546 108.773 101.546Z",
    stroke: "#0B2B46",
    strokeWidth: 2.13333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.548 74.1488H39.4727V65.4863H114.548V74.1488Z",
    fill: "#0B2B46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.647 92.7816H96.8719C95.2772 92.7816 93.9844 91.4888 93.9844 89.8941V87.0066C93.9844 85.412 95.2772 84.1191 96.8719 84.1191H102.647C104.242 84.1191 105.534 85.412 105.534 87.0066V89.8941C105.534 91.4888 104.242 92.7816 102.647 92.7816Z",
    fill: "#0B2B46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.81 80C130.848 80 140.621 89.7733 140.621 101.81C140.621 113.848 130.848 123.621 118.81 123.621C106.773 123.621 97 113.848 97 101.81C97 89.7733 106.773 80 118.81 80Z",
    fill: "#95CBB2",
    stroke: "#95CBB2",
    strokeWidth: 2.44633
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.27 103.441L114.304 109.475L129.036 94.7432",
    stroke: "white",
    strokeWidth: 2.71814,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.805 82.5886C135.889 81.504 136.846 80.5469 136.846 80.5469",
    stroke: "#95CBB2",
    strokeWidth: 2.29585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.594 89.9461C142.678 88.8614 143.635 87.9043 143.635 87.9043",
    stroke: "#95CBB2",
    strokeWidth: 2.29585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M139.934 84.4898C142.096 82.3729 144.003 80.5049 144.003 80.5049",
    stroke: "#95CBB2",
    strokeWidth: 2.29585,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5073_30898",
    x1: 77,
    y1: 0.711483,
    x2: 77.2541,
    y2: 154.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6EBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D7DEE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F7F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeSuccess);
export default __webpack_public_path__ + "static/media/charge-success.98961e55750045a5671d52d34462f89d.svg";
export { ForwardRef as ReactComponent };